import PropTypes from 'prop-types';
import React from 'react';
import axios from 'axios';
import { includes } from 'lodash';
import { isLoggedIn, getAccount, getAuthHeader } from '../../helpers/securityHelper';
import { IconFavoriteBorder } from '../../components/sharedComponents/icons/Icons';

class FavoriteHeart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            liked: false,
            loggedIn: false
        };

        this.addToFavorites = this.addToFavorites.bind(this);
        this.removeFromFavorites = this.removeFromFavorites.bind(this);
        this.toggleHeart = this.toggleHeart.bind(this);
    }

    componentWillMount(){
        const loggedIn = isLoggedIn();
        this.setState({
            loggedIn
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.loggedIn && this.props.id && this.props.id !== nextProps.id) {
            let liked = false;
            const account = getAccount();
            liked = includes(account.favorites, nextProps.id);
            this.setState({
                liked
            });
        }
    }

    setLocalStorageAccount(account) {
        window.localStorage.setItem('recaccount', JSON.stringify(account));
    }

    addToFavorites() {
        const url = '/api/accounts/favorites';
        const data = {
            id: this.props.id
        };
        axios.post(url, data, { headers: { Authorization: getAuthHeader() } }).then((response) => {
            this.setLocalStorageAccount(response.data);
            this.setState({
                liked: true
            });
        })
            .catch(() => {
                // TODO what happens when there is an error?
                this.setState({
                    liked: false
                });
            });
    }

    removeFromFavorites() {
        const url = `/api/accounts/favorites/${this.props.id}`;
        axios.delete(url, { headers: { Authorization: getAuthHeader() } }).then((response) => {
            this.setLocalStorageAccount(response.data);
            this.setState({
                liked: false
            });
        })
            .catch(() => {
                // TODO what happens when there is an error?
                this.setState({
                    liked: true
                });
            });
    }

    toggleHeart(e) {
        e.preventDefault();
        if (this.state.liked) {
            this.removeFromFavorites();
        }
        else {
            this.addToFavorites();
        }
    }

    render() {
        const showFavoriteText = this.props.showFavoriteText;
        let heartClass = 'rec-favorite-heart-unliked';
        let heart = (<IconFavoriteBorder />);
        if (this.state.liked) {
            heart = (<IconFavoriteBorder />);
            heartClass = 'rec-favorite-heart-liked';
        }
        if ( this.state.loggedIn ) {
            return (
                <div className="rec-favorite-heart-wrapper">
                    <button
                        className={`rec-button-link rec-favorite-heart ${heartClass}`}
                        onClick={(e) => {
                            this.toggleHeart(e);
                        }}>
                        {heart}
                        {showFavoriteText ? <span className="rec-favorite-text">Favorite</span> : null}
                    </button>
                </div>
            );
        }
        return null;
    }
}

FavoriteHeart.propTypes = {
    id: PropTypes.string,
    showFavoriteText: PropTypes.bool
};

export default FavoriteHeart;
